module.exports = __webpack_public_path__ + "img/HongJianTou.32f444bf.svg";